import * as utils from "@twiage/utils";
import { defineStore } from "pinia";
import { reactive, readonly, toRefs } from "vue";

import type { GeneralStoreState } from "../types/GeneralStoreState.js";
import type { ToggleUseFluidLayout } from "../types/ToggleUseFluidLayout";
import type { ToggleUseModals } from "../types/ToggleUseModals";
import { toggleUseFluidLayout } from "./actions/toggle-use-fluid-layout";
import { toggleUseModals } from "./actions/toggle-use-modals";
import { toggleUseScrollFieldsOnly } from "./actions/toggle-use-scroll-fields-only";
import { getInitialGeneralStoreState } from "./get-initial-general-store-state.js";

export const useGeneralStore = defineStore("general", () => {
  const state = reactive<GeneralStoreState>(getInitialGeneralStoreState());

  const actions = {
    toggleUseFluidLayout: utils.injectState<
      ToggleUseFluidLayout,
      GeneralStoreState
    >(toggleUseFluidLayout, state),

    toggleUseModals: utils.injectState<ToggleUseModals, GeneralStoreState>(
      toggleUseModals,
      state,
    ),

    toggleUseScrollFieldsOnly: utils.injectState<
      ToggleUseModals,
      GeneralStoreState
    >(toggleUseScrollFieldsOnly, state),
  };

  const $reset = () => Object.assign(state, getInitialGeneralStoreState());

  utils.mainEventBus.on("Authentication.User.Logout_after", $reset);

  return {
    ...actions,
    ...toRefs(readonly(state)),
    $reset,
  };
});
